import React, { FC } from "react";
import { Worker } from "@react-pdf-viewer/core";
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const PdfViewer: FC<{ docId?: string; URL?: string }> = ({ docId, URL }) => {
  const url = `https://docs.google.com/document/d/${docId}/export?format=pdf`;
  const chatPdf = URL;
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
      {docId && url ? (
        <div className=" min-h-[500px]">
          <Viewer fileUrl={url} />;
        </div>
      ) : (
        URL && chatPdf && <Viewer fileUrl={chatPdf} />
      )}
    </Worker>
  );
};

export default PdfViewer;
